import { render, staticRenderFns } from "./RestaurantsBuyNowButton.vue?vue&type=template&id=1f482ef5&scoped=true&"
import script from "./RestaurantsBuyNowButton.vue?vue&type=script&lang=ts&"
export * from "./RestaurantsBuyNowButton.vue?vue&type=script&lang=ts&"
import style0 from "./RestaurantsBuyNowButton.vue?vue&type=style&index=0&id=1f482ef5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f482ef5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f482ef5')) {
      api.createRecord('1f482ef5', component.options)
    } else {
      api.reload('1f482ef5', component.options)
    }
    module.hot.accept("./RestaurantsBuyNowButton.vue?vue&type=template&id=1f482ef5&scoped=true&", function () {
      api.rerender('1f482ef5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Availability/view/vue/components/buttons/RestaurantsBuyNowButton.vue"
export default component.exports